  export const  loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  export  const urlToBase64 = async (url) => {
      const res = await fetch(url);
      const blob = await res.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
  };

export const convertToGrayScale = (dataUrl) =>
  new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
          data[i] = avg;
          data[i + 1] = avg;
          data[i + 2] = avg;
        }

        ctx.putImageData(imageData, 0, 0);

        resolve(canvas.toDataURL("image/png"));
      } catch (err) {
        reject(err);
      }
    };

    img.onerror = (err) => {
      console.error("Image failed to load", err);
      reject(err);
    };

    img.src = dataUrl;
  });

  export const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };
  
  export const getSaleTrack = (status) => {
      switch (status) {
        case "ADDED":
          return "Original";
        case "UPDATED":
          return "Modified";
        case "DELETED":
          return "Cancelled";
        default:
          return status;
      }
  };

  export const joinAddress = (...lines) =>
    lines
      .map((l) => l?.trim())
      .filter(Boolean)
  .join(", ");

  export const calcBoxHeight = (lines, lineHeight = 4, padding = 14) => {
    return lines.length * lineHeight + padding;
  };  
 
  export const wrapText = (doc, text, width) => {
    if (!text) return [];
    return doc.splitTextToSize(text, width);
  };

  export const capitalizeFirstLetter = (text) =>
  text ? text.charAt(0).toUpperCase() + text.slice(1) : ""; 

  // Place this outside your component or inside the function body
export const parseAmount = (val) => {
  if (!val) return 0;

  const numericString = String(val).replace(/[^0-9.-]+/g, "");
  const amount = parseFloat(numericString);

  return Number.isNaN(amount) ? 0 : Math.abs(amount);
};